/**
 * Non-blocking notification delivery modes (spec: NOTIFICATION_CENTER_AND_DIALOGS_SPEC.md §3).
 * Exactly one mode applies per notify call.
 *
 * @readonly
 * @enum {string}
 */
export const NOTIFICATION_DELIVERY = {
  SNACKBAR_ONLY: "SNACKBAR_ONLY",
  SNACKBAR_AND_INBOX: "SNACKBAR_AND_INBOX",
  INBOX_ONLY: "INBOX_ONLY",
};

/**
 * Default delivery per severity (product policy §4). Override with `notify.*(msg, { delivery })` + comment.
 * success → SNACKBAR_ONLY; info → SNACKBAR_ONLY; warning/error → SNACKBAR_AND_INBOX (read in inbox).
 */
export const DEFAULT_NOTIFICATION_DELIVERY_BY_SEVERITY = {
  success: NOTIFICATION_DELIVERY.SNACKBAR_ONLY,
  info: NOTIFICATION_DELIVERY.SNACKBAR_ONLY,
  warning: NOTIFICATION_DELIVERY.SNACKBAR_AND_INBOX,
  error: NOTIFICATION_DELIVERY.SNACKBAR_AND_INBOX,
};

/** Max persisted inbox rows (spec §6). */
export const NOTIFICATION_INBOX_MAX_ITEMS = 100;

/** Persisted JSON envelope version (spec §6). Bump when shape changes; loader migrates or discards. */
export const NOTIFICATION_INBOX_SCHEMA_VERSION = 2;

/** Previous envelope version; loader accepts v1 rows (no actionRoute/actionLabel) and re-saves as v2. */
export const NOTIFICATION_INBOX_SCHEMA_VERSION_PREVIOUS = 1;

/** BroadcastChannel name for cross-tab inbox sync (spec §6). */
export const NOTIFICATION_INBOX_BROADCAST_CHANNEL = "cai3p0:notifications:inbox-v1";
